import gql from 'graphql-tag';

export const ResendInviteEmail = gql`
  mutation ResendInviteEmail($organizationId: ID!, $userId: ID!) {
    resendInviteEmail(organizationId: $organizationId, userId: $userId)
  }
`;
